import { WrapperTwoLayout } from '@/components/Layouts';
import { Banner, TabWrapper } from '@/components/Shared';
import { BannerCustomizeHeight } from '@/components/Shared';
import {
  Image_Subtypes_Enum,
  Layout_Page_Tops_Enum,
  Order_By,
  useGetBannerQuery,
} from '@/generated/graphql';
import { ICategoryTopSection } from '@/interfaces/category';
import format from '@/utils/format';

const CategoryTopSection = ({
  slug,
  name,
  posts,
  categories,
  small,
  layoutPageTop,
}: ICategoryTopSection) => {
  const dataPost = format.formatDataPost(posts);
  const dataCategory = format.formatDataCategory(
    categories,
    slug || '',
    name || '',
  );

  const { data: dataBanner } = useGetBannerQuery({
    variables: {
      where: {
        _or: [
          {
            _and: [
              {
                position: {
                  _in: [
                    Image_Subtypes_Enum.LargeCategoryRight_1,
                    Image_Subtypes_Enum.SmallCategoryRight_1,
                  ],
                },
                banners_categories: {
                  category: {
                    path_full_slug: {
                      full_slug: {
                        _eq: slug,
                      },
                    },
                  },
                },
              },
            ],
          },
          {
            _and: [
              {
                position: {
                  _in: [
                    Image_Subtypes_Enum.LargeCategoryRight_1,
                    Image_Subtypes_Enum.SmallCategoryRight_1,
                  ],
                },
                banners_categories_aggregate: {
                  count: {
                    predicate: {
                      _eq: 0,
                    },
                  },
                },
              },
            ],
          },
        ],
      },
      orderBy: [
        {
          banners_categories_aggregate: {
            count: Order_By.DescNullsLast,
          },
        },
      ],
    },
  });

  return (
    <div className="h-fit min-h-[464px]">
      <WrapperTwoLayout
        leftColumn={
          <div className="lg:pr-10">
            <TabWrapper
              category={dataCategory}
              data={dataPost || []}
              layout={layoutPageTop ?? Layout_Page_Tops_Enum.OneLargeFiveSmall}
            />
          </div>
        }
        rightColumn={
          <>
            <div
              className={`w-full hidden lg:block h-[350px] ${
                layoutPageTop === Layout_Page_Tops_Enum.TwoLargeTwoSmall
                  ? 'lg:h-[589px]'
                  : 'lg:h-[504px]'
              }`}
            >
              {small ? (
                <Banner
                  data={dataBanner?.banners.filter(
                    item =>
                      item.position ===
                      Image_Subtypes_Enum.SmallCategoryRight_1,
                  )}
                />
              ) : (
                <Banner
                  data={dataBanner?.banners.filter(
                    item =>
                      item.position ===
                      Image_Subtypes_Enum.LargeCategoryRight_1,
                  )}
                />
              )}
            </div>
            <div className={`w-full block lg:hidden`}>
              {small ? (
                <BannerCustomizeHeight
                  data={dataBanner?.banners.filter(
                    item =>
                      item.position ===
                      Image_Subtypes_Enum.SmallCategoryRight_1,
                  )}
                />
              ) : (
                <BannerCustomizeHeight
                  data={dataBanner?.banners.filter(
                    item =>
                      item.position ===
                      Image_Subtypes_Enum.LargeCategoryRight_1,
                  )}
                />
              )}
            </div>
          </>
        }
      />
    </div>
  );
};

export default CategoryTopSection;
